module.exports = __webpack_public_path__ + "d8d7173de71c1c8b502fbe91d0b96ea1.svg";